<template>
    <div class="add-text-page" id="add-text-page">

        <app-loading 
            v-if="loading"
        />

        <app-header 
            :position="'fixed'"
            :top="'0px'"
            :background="'transparent'"
            :infoButton="true"
            @clickMenu="change_menu(context, true)"
            @clickInfoButton="text_click_info(context)"
        />

        <div class="add-text-page__container">

          <app-player-no-blob
              v-for="(item, index) in preview"
              v-if="item.video"
              :key="key_video"
              :index="index"
              :type="'text'"
              :id="item.id"
              :video="item.video"
              :webm="item.webm"
              :descr="item.descr"
              @playVideo=" footerStatus ? text_play_video(context) : text_blur_input(context)"
          />


            <div class="add-text-page__input"
                id="add-text-page__input"
                :class="{'add-text-page__input-margin' : selectColorStatus}"
                @click="footerStatus = false"
            >
                <input
                    placeholder="Введите текст..."
                    autocomplete="off"
                    :value="text"
                    rows="1"
                    :maxlength="maxSymbol"
                    id="add-text-page__textarea"
                    @input="text_enter_text(context, $event.target.value)"
                    @focus="text_player_default()"
                    @keyup.enter="text_keyup_enter(context)"
                    :style="{color: `${textColor}`}"
                >
                <div class="add-text-page__input-counter">
                    {{counterText}}/{{maxSymbol}}
                </div>
                <div class="add-text-page__input-colors"
                    @click="text_click_selector_colors(context)"
                >
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.17558 8.17562L3.80758 3.80762C1.45509 6.16021 0 9.41016 0 13H6.17729C6.17729 11.116 6.94093 9.41031 8.17558 8.17562Z" fill="#00B76C"/>
                        <path d="M6.17729 13H0C0 16.5899 1.45509 19.8399 3.80758 22.1924L8.17558 17.8244C6.94093 16.5897 6.17729 14.884 6.17729 13Z" fill="#546F7A"/>
                        <path d="M8.17549 17.8242L3.8075 22.1922C6.15999 24.5448 9.41004 25.9998 12.9999 25.9998V19.8225C11.1159 19.8226 9.41019 19.0589 8.17549 17.8242Z" fill="#3D4FF9"/>
                        <path d="M13 19.8225V25.9998C16.5899 25.9998 19.8399 24.5447 22.1924 22.1922L17.8244 17.8242C16.5897 19.0589 14.884 19.8225 13 19.8225Z" fill="#39A4FA"/>
                        <path d="M19.8227 13C19.8227 14.884 19.059 16.5897 17.8243 17.8244L22.1923 22.1924C24.5449 19.8399 25.9999 16.5899 25.9999 13.0001L19.8227 13Z" fill="#8B41F7"/>
                        <path d="M19.8226 13H25.9999C25.9999 9.41011 24.5448 6.16011 22.1923 3.80762L17.8243 8.17562C19.059 9.41026 19.8226 11.116 19.8226 13Z" fill="#FF434D"/>
                        <path d="M17.8244 8.17558L22.1924 3.80758C19.8398 1.45509 16.5898 0 13 0V6.17729C14.884 6.17729 16.5897 6.94093 17.8244 8.17558Z" fill="#FF6137"/>
                        <path d="M12.9999 6.17729V0C9.41004 0 6.16004 1.45509 3.8075 3.80758L8.17549 8.17558C9.41019 6.94093 11.1159 6.17729 12.9999 6.17729Z" fill="#FFD039"/>
                    </svg>
                </div>
                <transition 
                    name="select-colors" 
                    appear
                    mode="out-in"
                >
                    <div class="add-text-page__select-colors"
                         @click.stop="setFucus()"
                        v-if="selectColorStatus"
                        :style="{top: `${pickColorsMarginBottom}px`}"
                    >
                        <div class="add-text-page__select-color"
                            v-for="(item, index) in colorsObj"
                            :key="item.background"
                            :index="index"
                        >
                            <div class="add-text-page__select-color-bgc"
                                @click.stop="text_set_color_text(context, item.background)"
                                :style="{backgroundColor: `${item.background}`}"
                            >

                            </div>
                        </div>
                        <div class="add-text-page__select-colors-button"
                            @click.stop="text_click_close_colors(context)"
                        >
                            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7 1L1 7M1 1L7 7" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </div>
                 </transition>
            </div>
        </div>

        <transition 
            name="footer-out" 
            appear
            mode="out-in"
        >
            <div class="add-text-page__footer"
                v-if="footerStatus"
            >
                <div class="add-text-page__footer-button"
                    v-if="!editeableItem"
                    :class="{'add-text-page__footer-button-active' : counterText > 0}"
                    @click="text_add_in_tape(context)"
                >
                    <span>Добавить в ролик</span>
                </div>

                <div class="add-text-page__footer-button"
                    v-if="editeableItem"
                    :class="{'add-text-page__footer-button-active' : counterText > 0}"
                    @click="text_replace(context)"
                >
                    <span>Заменить текст</span>
                </div>
            </div> 
        </transition>

        <transition 
            name="fade-menu" 
            appear
            mode="out-in"
        >
            <app-menu 
                v-if="menu"
                idLogoMenu="header-component__menu"
                @clickLink="change_menu(context, false)"
                @clickOutside="change_menu(context, false)"
            />
        </transition >

        <transition 
            name="fade-overlay" 
            appear
            mode="out-in"
        >
            <app-overlay 
                v-if="overlay"
            />
        </transition>   

        <transition 
            name="default-fade" 
            appear
            mode="out-in"
        >
            <app-popup
                :is_slot="true"
                :growButton="popup.growButton"
                v-if="popup.value"
                @clickButton="close_popup(context)"
            >
              <template
                  v-slot:header
              >
                <div class="add-text-page__alert-wrapper">
                  <div class="add-text-page__alert">
                    Нельзя: плохие слова, контактная информация, политические слоганы, реклама, несоответствие выбранному поводу.<br><br>
                    Текст поздравления должен быть на русском языке.
                    При нарушении правил деньги не возвращаем.<br><br>
                    Можно: приятные пожелания и теплые слова :)<br><br>
                  </div>
                  <div class="add-text-page__alert-button" @click="$router.push('/offer?id=2')">
                    Читать полностью
                  </div>
                </div>
              </template>
            </app-popup>
        </transition>    
    </div>
</template>

<script>

    const AppLoading = () => import('@/components/loading.vue')
    const AppHeader = () => import('@/components/header.vue')
    const AppPopup = () => import('@/components/popups/popup-color.vue')
    const AppOverlay = () => import('@/components/overlay.vue')
    const AppMenu = () => import('@/components/menu.vue')
    const AppPlayer = () => import('@/components/player.vue')
    const AppPlayerNoBlob = () => import('@/components/onePlayerNoBlob')

    import text_mounted_hook from "@/views/add_text/modules/text_mounted_hook";
    import change_menu from "@/views/theme/modules/change_menu";
    import text_click_info from "@/views/add_text/modules/text_click_info";
    import close_popup from "@/views/video_editor/modules/close_popup";
    import text_validate from "@/views/add_text/modules/text_validate";
    import text_player_default from "@/views/add_text/modules/text_player_default";
    import text_blur_input from "@/views/add_text/modules/text_blur_input";
    import text_keyup_enter from "@/views/add_text/modules/text_keyup_enter";
    import text_enter_text from "@/views/add_text/modules/text_enter_text";
    import text_click_selector_colors from "@/views/add_text/modules/text_click_selector_colors";
    import text_click_close_colors from "@/views/add_text/modules/text_click_close_colors";
    import text_set_color_text from "@/views/add_text/modules/text_set_color_text";
    import text_add_in_tape from "@/views/add_text/modules/text_add_in_tape";
    import text_replace from "@/views/add_text/modules/text_replace";
    import text_play_video from "@/views/add_text/modules/text_play_video";

    export default {
        async mounted() {
          this.text_mounted_hook(this)
        },
        destroyed() {
          this.$store.dispatch('cache_videos_page_context/clearCacheVideo')
        },
        data() {
            return {
                context: this,
                overlay: false,
                menu: false,
                key_video: `f${(~~(Math.random()*1e8)).toString(16)}`,
                rendering: false,
                footerStatus: true,
                maxSymbol: 0,
                video: {
                    mp4: false,
                    webm: false,
                },
                text: '',
                rowsTextarea: 1,
                popup: {
                    value: false,
                    text: '',
                    growButton: false
                },
                selectColorStatus: false,
                counterText: 0,
                pickColorsMarginBottom: 0,
                textColor: '#FFFFFF',
            }
        },
        components: {
            AppHeader,
            AppPopup,
            AppLoading,
            AppOverlay,
            AppMenu,
            AppPlayer,
            AppPlayerNoBlob
        },
        watch: {
            editeableItem(val) {
                if(val) {
                    this.text = val.descr
                }
            },
            text(val) {
                this.counterText = val.length
            }
            
        },
        methods: {
          text_mounted_hook,
          change_menu,
          text_click_info,
          close_popup,
          text_validate,
          text_player_default,
          text_blur_input,
          text_keyup_enter,
          text_enter_text,
          text_click_selector_colors,
          text_click_close_colors,
          text_set_color_text,
          text_add_in_tape,
          text_replace,
          text_play_video,
          async setFucus() {
            document.getElementById('add-text-page__textarea').focus();
          }
        },
        computed: {
            loading() {
              return !this.rendering
            },
            main() {
                return this.$store.getters['main_videos/main']
            },
            editeableItem() {
                return this.$store.getters['edit/editableItem']
            },
            preview() {
                return [{
                    duration: (this.text.length > 3 ? this.text.length : 3),
                    id: `f${(~~(Math.random()*1e8)).toString(16)}`,
                    img: 'text-icon.png',
                    index: this.editeableItem ? this.editeableItem.index : this.main.length,
                    name: 'text',
                    status: false,
                    timecode: true,
                    type: 'text',
                    descr: this.text,
                    color: this.textColor,
                    video: this.video.mp4,
                    webm: this.video.webm,
                    speedText: this.speedText
                }]
            },
            maxSymbolComputed() {
                return this.$store.getters['settings/maxSymbol']
            },
            freeSeconds() {
                return this.$store.getters['settings/freeSeconds']
            },
            speedText() {
                return this.$store.getters['settings/newSpeedText']
            },
            mp4() {
                return this.$store.getters['settings/backgroundVideoMp4']
            },
            webm() {
                return this.$store.getters['settings/backgroundVideoWebm']
            },
            colorsObj() {
              return this.$store.getters['settings/backgrounds']
            }
        }
    }
</script>

<style lang="less">
    .add-text-page {
        background-color: black;
        width: 100%;
        height: calc(var(--vh, 1vh) * 100);
        min-height: 500px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
    }

    #add-text-page .header-component {
        z-index: 15;
    }

    .add-text-page__container {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 0;
        position: relative;
    }

    #add-text-page .player-component {
        position: absolute;
        opacity: 1;
    }

    @import '~/assets/fonts/roboto/Roboto-Light.less';

    .add-text-page__input {
        position: absolute;
        width: 100%;
        padding-left: 6px;
        padding-right: 6px;
        bottom: 8px;
        display: flex;
        min-height: 40px;
        display: flex;
        align-items: center;
        transition: all .15s linear;
    }

    .add-text-page__input input {
        width: 100%;
        display: flex;
        border-radius: 20px;
        border: 0.5px solid rgba(255, 255, 255, 0.5);
        background-color: black;
        color: white;
        padding-left: 22px;
        padding-right: 50px;
        font-family: 'Roboto-Light';
        height: 40px;
        resize: none;
        overflow: hidden;
        white-space: nowrap;
        outline:none;
    }

    .add-text-page__input textarea:focus {
        outline: none;
    }

    .add-text-page__input textarea::placeholder {
        color: white;
        opacity: 0.4;
        font-family: 'Roboto-Light';
    }

    .add-text-page__input-counter {
        color: #C4C4C4;
        font-size: 13px;
        line-height: 20px;
        font-family: 'Roboto-Light';
        position: absolute;
        top: -20px;
        right: 13px;

    }

    .add-text-page__input-colors {
        position: absolute;
        bottom: 3px;
        right: 15px;
        cursor: pointer;
    }
    
    .add-text-page__input-margin {
        margin-bottom: 40px;
    }

    .select-colors-enter-active {
        animation: select-colors .15s linear;
    }

    .select-colors-leave-active {
        animation: select-colors .15s linear reverse;
    }

    @keyframes select-colors {

        0% {
            top: 90px;
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    .add-text-page__select-colors {
        display: flex;
        background: #1B1C2D;
        align-items: center;
        position: absolute;
        left: 0px;
        width: 100%;
        overflow: hidden;
        transition: all .15s linear;
        padding-left: 16px;
        padding-right: 16px;
        height: 32px;
    }

    .add-text-page__select-color {
        width: 26px;
        height: 26px;
        border-radius: 100%;
        overflow: hidden;
        margin-right: 5px;
        margin-left: 5px;
        cursor: pointer;
    }

    .add-text-page__select-color-bgc {
        width: 100%;
        height: 100%;
    }

    .add-text-page__select-colors-button {
        position: absolute;
        right: 10px;
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .footer-out-enter-active {
        animation: footer-fade .2s linear;
    }

    .footer-out-leave-active {
        animation: footer-fade .2s linear reverse;
    }

    @keyframes footer-fade {
        0% {
            opacity: 0;
            height: 0px;
        }

        100% {
            opacity: 1;
            height: 208px;
        }
    }

    .add-text-page__footer {
        opacity: 1;
        width: 100%;
        background-color: #2F1F4C;
        height: 208px;
        flex-grow: 1;
        display: flex;
        align-items: flex-end;
        padding-bottom: 16px;
        z-index: 5;
    }

    @import '~/assets/fonts/montserrat/Montserrat-Medium.less';

    .add-text-page__footer-button {
        font-family: 'Montserrat-Medium';
        margin-left: 16px;
        margin-right: 16px;
        height: 44px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FFFFFF;
        font-size: 16px;
        line-height: 12px;
        opacity: .5;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 5px;
    }

    .add-text-page__alert-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .add-text-page__alert {
      text-align: center;
      font-size: 15px;
      color: #ffffff;
      font-family: 'Roboto-Light';
    }

    .add-text-page__alert-button {
      font-family: 'Roboto-Light';
      font-size: 15px;
      color: #ffffff;
      margin-top: 10px;
      border-bottom: 1px dashed #ffffff;
      cursor: pointer;
      text-decoration: none;
    }

    .add-text-page__footer-button-active {
        background: #FFFFFF;
        opacity: 1;
        color: #31283D;
        cursor: pointer;
    }
</style>